export type PagedResponse<T> = {
  count: number;
  page: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  pageSize: number;
  value: T[];
};

export interface ChatMessage {
  id: string;
  topicId: string;
  threadId: string;
  userId: string;
  externalId: string;
  senderName: string;
  content: string;
  messageType: string;
  metadata: { [key: string]: string };
  media: { [key: string]: string };
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
  readReceipts: { [key: string]: string };
}

export interface ChatMessageRequest {
  from?: Date;
  to?: Date;
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortDirection?: string;
}

export enum ThreadType {
  HealthManagerChannel = 'HealthManagerChannel',
  SupportChannel = 'SupportChannel',
}

export interface ChatThread {
  id: string;
  name: string;
  threadType: ThreadType;
  userIds: string[];
  topicIds: string[];
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
  ownerId?: string;
  ownerName?: string;
  latestSentMessage?: string;
  lastSentAt?: Date;
  assignees?: string[];
  labels?: string[];
}

export interface ChatThreadSearchRequest {
  value?: string;
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortDirection?: string;
}

export interface ChatThreadRequest {
  id?: string;
  name?: string;
  ownerId?: string;
  ownerName?: string;
  latestSentMessage?: string;
  lastSentAt?: Date;
  labels?: string[];
  threadType?: ThreadType;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortDirection?: string;
}
